module.exports = __webpack_public_path__ + "img/image_gallery7.b66dac8b.jpg";